import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import App from './App.vue';
import './registerServiceWorker'; // 确保路径正确
import router from './router';
import store from './store';
import '@fortawesome/fontawesome-free/css/all.css';

createApp(App).use(store).use(router).use(ElementPlus,{locale: zhCn,}).mount('#app');